// generated by the plop

import { ReceiptContainerModel, TemplateModel } from 'shared';
import { PROGRESS_STATUSES, UUID } from 'symbols';

export interface TrafficManageStateModel {
  currentTrafficId: UUID;
  traffics: { [trafficId: string]: ReceiptContainerModel };
  loadTrafficStatus: PROGRESS_STATUSES;
  updateTrafficStatus: PROGRESS_STATUSES;
  trafficTemplateList: TemplateModel[];
  loadTemplateListStatus: PROGRESS_STATUSES;
}

export const TRAFFIC_MANAGE_STATE_DEFAULT: TrafficManageStateModel = {
  currentTrafficId: null,
  traffics: {},
  loadTrafficStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  updateTrafficStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  trafficTemplateList: [],
  loadTemplateListStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
